// ReloadPrompt.tsx
import React, { useEffect, useMemo } from "react"
import { useRegisterSW } from "virtual:pwa-register/react"
import toast from "lib/toast"
import { RefreshPageIcon } from "components-old/icons"

function ReloadPrompt() {
  const isControlled = useMemo(() => typeof navigator !== "undefined" && !!navigator.serviceWorker?.controller, [])

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log("SW Registered")

      // Só inicia o poll de update se já houver um SW controlando a página.
      if (r && isControlled) {
        const id = setInterval(() => r.update(), 30 * 60 * 1000)
        // opcional: limpar no unload
        window.addEventListener("beforeunload", () => clearInterval(id))
      }
    },
    onRegisterError(error) {
      console.log("SW registration error", error)
    },
  })

  useEffect(() => {
    // 1) NUNCA mostre "nova versão" por causa do offlineReady (primeira instalação)
    // 2) Só mostre se existe um SW anterior (página controlada) e realmente há update.
    if (isControlled && needRefresh) {
      toast.mention(
        {
          title: "Nova versão disponível",
          content: "Clique aqui para atualizar a página e usar a nova versão.",
          icon: <RefreshPageIcon className="fill-blue-600 size-12" />,
          onClick: () => updateServiceWorker(true),
        },
        { duration: Infinity },
      )
    }

    // Se quiser mostrar um TOAST diferente quando o app ficar pronto offline
    // (mas não na primeira visita), você pode fazer:
    // if (isControlled && offlineReady) { ...toast opcional "App disponível offline" }
  }, [isControlled, needRefresh, offlineReady, updateServiceWorker])

  return null
}

export default ReloadPrompt
